module.exports = __webpack_public_path__ + "static/img/style_4.b4618a85.png";